import { render, staticRenderFns } from "./WeiboCard.vue?vue&type=template&id=78921f8d&scoped=true&"
import script from "./WeiboCard.vue?vue&type=script&lang=js&"
export * from "./WeiboCard.vue?vue&type=script&lang=js&"
import style0 from "./WeiboCard.vue?vue&type=style&index=0&id=78921f8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78921f8d",
  null
  
)

export default component.exports